import React from "react";

import ResetPasswordForm from "../component/Register/ResetPasswordForm";


const ResetPasswordpage = () => {

  return (
    <section className="text-gray-900 transition-colors bg-bg-light-primary dark:bg-bg-dark-primary dark:text-gray-100">
      <div className="">
        <ResetPasswordForm />
      </div>
    </section>
  );
};

export default ResetPasswordpage;
